import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import "../styles/home.css";
import "../styles/theme.css";
import Layout from "./Layout";

let transData: {};

const Home: React.FC = () => {

    useEffect(() => {
        // For future session management and other factors

    }, []);

   
    return (
        <Layout>
            <div className="home-container">
                <h2 className="home-header">FuelSure Analytics Portal</h2>
            </div>
        </Layout>
    );
};

export default Home;